export default class ParametrosCatalogo {
    constructor(
        public catalogParentId: string = null,
        public codigo: string = null
    ) {}
}